module.exports = __webpack_public_path__ + "static/media/Defeat.81d3fd0c.png";